import React, {Component} from 'react';
import {connect} from 'react-redux';
import {history} from '../../../store';
import IgniteDataTable from '../../common/datatable';
import ConfirmPopup from '../../common/confirm-popup';
import {getLevels, setAsDefaultLevel} from '../../../actions/levels';
import './styles.css';

const columns = [
  {
    prop: 'name',
    title: 'Name',
    width: 200,
    format: data => <span style={ { whiteSpace: 'normal' } }>{data}</span>
  },
  {
    prop: 'next-level-name',
    title: 'Next level',
    width: 200,
  },
  {
    prop: 'active',
    title: 'Active',
    width: 60,
    format: data => <div className="text-center">{data ? 'Y' : 'N'}</div>
  },
];

class LevelList extends Component {
  state = {
    default: {
      show: false,
    }
  };


  handleSetAsDefault = (result) => {
    const {id} = this.state.default;
    const {dispatch} = this.props;

    this.setState({
      default: {
        show: false,
        id: undefined,
      }
    });

    if (result) {
      dispatch(setAsDefaultLevel(id)).then(() => dispatch(getLevels()));
    }
  };

  render() {
    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'modify',
          subjectClass: 'Level'
        },
        callback: (row) => {
          history.push(`/admin/levels/${row.id}`);
        }
      },
      {
        label: 'Set as default',
        color: 'grey',
        permissions: {
          action: 'modify',
          subjectClass: 'Level'
        },
        disabled: row => row.attributes.default,
        callback: (row) => {
          this.setState({
            default: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];

    const {default: {show: showSetAsDefaultConfirmation}} = this.state;
    const {levels} = this.props;

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={levels}
          inlineActions
        />

        {showSetAsDefaultConfirmation && (
          <ConfirmPopup
            header=""
            onClose={this.handleSetAsDefault}
            confirmLabel="Continue"
          >
            <p>
              Are you sure you want to change the default level?
              Changing this level will mean any newly registered outlets will start at this level.
            </p>
          </ConfirmPopup>
        )}
      </div>
    );
  }
}

export default connect()(LevelList);



// WEBPACK FOOTER //
// ./src/components/admin/levels/level-list.jsx